
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M28 14.446v2.058C21.1 18.28 16 24.544 16 32c0 8.837 7.163 16 16 16s16-7.163 16-16c0-7.455-5.099-13.72-12-15.496v-2.058c8.016 1.82 14 8.988 14 17.554 0 9.941-8.059 18-18 18s-18-8.059-18-18c0-8.566 5.984-15.735 14-17.554zM33 10a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V11a1 1 0 011-1h2z"}})])
          )
        }
      }
    